import {getMethod, postMethod} from '~/api'

async function post(request) {
    return await postMethod('/proxy/clientsTableOptions', request)
}

async function get(request) {
    return await getMethod('/proxy/clientsTableOptions', request)
}

export {post, get}
